module.exports = __webpack_public_path__ + "img/FolderFile.d6adf3d1.svg";